import style from './App.module.css'
import { Input } from './components/Input/Input';
import { Button } from './components/Button/Button';
import { useEffect, useState } from 'react';
import { login, getOffice, loginIntern } from './api/apiLogin';
import { Logo } from './components/Logo/Logo';
import { GlowingTree } from './components/GlowingTree/GlowingTree';
import treeIcon from "./assets/tree.png"
import treeMask from "./assets/mask-tree.png"
import presentIcon from "./assets/presents.png"
import Snowfall from 'react-snowfall';


function App() {
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [textError, setTextError] = useState('')
  const [textSuccess, setTextSuccess] = useState('')
  const [isOffice, setIsOffice] = useState(false)

  const [bgColor, setBgColor] = useState('#F5F6FA');

  const lerpColor = (color1, color2, t) =>
    color1.map((c, i) => Math.round(c + (color2[i] - c) * t));

  const rgbToHex = (rgb) =>
    '#' + rgb.map(x => x.toString(16).padStart(2, '0')).join('');

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.slice(1), 16);
    return [(bigint >> 16) & 255, (bigint >> 8) & 255, bigint & 255];
  };

  // Цвета для времён суток
  const NIGHT = hexToRgb('#1A1A2E');
  const MORNING = hexToRgb('#D9DBE1');
  const DAY = hexToRgb('#F5F6FA');
  const EVENING = hexToRgb('#E1E3EA');

  const getBackgroundColor = () => {
    const now = new Date();
    const hour = now.getHours() + now.getMinutes() / 60;

    let startColor, endColor, t;

    if (hour >= 18 || hour < 8) { // ночь
      startColor = NIGHT;
      endColor = MORNING;
      // t для ночи пересекает полночь
      t = hour >= 18 ? (hour - 18) / 14 : (hour + 6) / 14; // ночь длится 14 часов
    } else if (hour >= 8 && hour < 10) { // утро
      startColor = MORNING;
      endColor = DAY;
      t = (hour - 8) / 2; // утро 2 часа
    } else if (hour >= 10 && hour < 16) { // день
      startColor = DAY;
      endColor = EVENING;
      t = (hour - 10) / 6; // день 6 часов
    } else { // вечер 16-18
      startColor = EVENING;
      endColor = NIGHT;
      t = (hour - 16) / 2; // вечер 2 часа
    }

    const color = lerpColor(startColor, endColor, t);
    return rgbToHex(color);
  };

  useEffect(() => {
    setBgColor(getBackgroundColor());
    const interval = setInterval(() => setBgColor(getBackgroundColor()), 60 * 1000);
    return () => clearInterval(interval);
  }, []);  

  function auth() {
    if (!username || !password) return;

    setTextError('')
    setTextSuccess('')

    setLoading(true)
    login(username, password).then(response => {      
      setLoading(false)
      const {message, status} = response.data
      if (status === 'ok') {
        setTextSuccess('Успешный вход.')
        document.location.href = `${document.location.origin}/new/sales/`
      } else {
        setTextError('Неверный логин или пароль.')
      }
    })
  }

  function authIntern() {
    setTextError('')
    setTextSuccess('')

    setLoading(true)
    loginIntern().then(response => {      
      setLoading(false)
      const {status} = response.data
      if (status === 'ok') {
        setTextSuccess('Успешный вход.')
        document.location.href = `${document.location.origin}/new/sale/`
      } else {
        setTextError('Ошибка быстрой авторизации.')
      }
    })    
  }

  useEffect(() => {
    getOffice().then(response => {      
      setIsOffice(response.data?.data?.is_office || false)
    })
  }, [])

  return (
    <div className={style.back} style={{"backgroundColor": bgColor}}>
      <Logo />
      <Snowfall snowflakeCount={500}/>
      <div className={style.container}>
      
        {
          (textError || textSuccess) &&
          <div className={textError ? style.error : style.success}>
            {textError || textSuccess}
          </div>          
        }

        <div style={{"position": "absolute", "left": "50px", "bottom": "50px"}}>
          <GlowingTree
            treeSrc={"https://app.insfamily.ru/media/tree.png"}
            maskSrc={"https://app.insfamily.ru/media/mask-tree.png"}
            width='300px'
          />
          
        </div>
        
        <img className={style.presetsBox} src={"https://app.insfamily.ru/media/presents.png"} alt='Подарочки' />  

        <div className={style.inputs}>
          <Input label='Логин'
            value={username}
            onInput={(e) => setUsername(e.target.value)}
            onKeyDown={auth}
          />
          <Input
            value={password}
            onInput={(e) => setPassword(e.target.value)}
            onKeyDown={auth}
            label='Пароль'          
            password
          />
        </div>

        <div className={style.buttons}>
          {
            isOffice &&
            <Button
              label='Я Стажёр'
              white
              onClick={authIntern}
            />
          }
          <Button
            label='Войти'
            onClick={auth}
            disabled={!username || !password || loading}
            loading={loading}
          />      
        </div>    
      </div>  
    </div>
  );
}

export default App;
